import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {HttpUtilsService} from '../_base/crud';
import {Injectable} from '@angular/core';

const API_HOMEPAGE_URL = `${environment.pathToAPI}/api/v1/homepage`;


@Injectable()
export class HomePageService {
    constructor(
        private http: HttpClient,
        private httpUtils: HttpUtilsService
    ) {
    }

    sendContactFormRequestToAdminMail(body: any) {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post(API_HOMEPAGE_URL + '/send-contact-form-request-to-admin-mail', body, {headers: httpHeaders});
    }

}
